import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ComboChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M7.5 26.5C7.5 25.6716 8.17157 25 9 25C9.82843 25 10.5 25.6716 10.5 26.5V30.5C10.5 31.3284 9.82843 32 9 32C8.17157 32 7.5 31.3284 7.5 30.5V26.5Z"
        fill="#CCBFFF"
      />
      <path
        d="M13.5 22.5C13.5 21.6716 14.1716 21 15 21C15.8284 21 16.5 21.6716 16.5 22.5V30.5C16.5 31.3284 15.8284 32 15 32C14.1716 32 13.5 31.3284 13.5 30.5V22.5Z"
        fill="#927BF0"
      />
      <path
        d="M19.5 18.5C19.5 17.6716 20.1716 17 21 17C21.8284 17 22.5 17.6716 22.5 18.5V30.5C22.5 31.3284 21.8284 32 21 32C20.1716 32 19.5 31.3284 19.5 30.5V18.5Z"
        fill="#CCBFFF"
      />
      <path
        d="M25.5 22.5C25.5 21.6716 26.1716 21 27 21C27.8284 21 28.5 21.6716 28.5 22.5V30.5C28.5 31.3284 27.8284 32 27 32C26.1716 32 25.5 31.3284 25.5 30.5V22.5Z"
        fill="#927BF0"
      />
      <path
        d="M7.5 17.5C9 12.5 14 8.5 18.2223 11.7085C22.4445 14.917 27 9.5 28 6"
        stroke="#927BF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
